import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";

interface InitialState {
  fakeNotificationListData: any;
  isLoading:boolean;
}

const initialState: InitialState = {
  fakeNotificationListData: [],
  isLoading:false
};

const fakeNotificationSlice = createSlice({
  name: "fakeNotification",
  initialState,
  reducers: {
    setFakeNotificationListData: (
      state: Draft<InitialState>,
      action: PayloadAction<any>
    ) => ({
      ...state,
      fakeNotificationListData: action.payload,
    }),
    setLoader: (
      state: Draft<InitialState>,
      action: PayloadAction<any>
    ) => ({
      ...state,
      isLoading: action.payload,
    }),
  },
});

export const { setFakeNotificationListData , setLoader } = fakeNotificationSlice.actions;

export default fakeNotificationSlice.reducer;
